import Vue from 'vue';
import axios from 'axios';

export async function fetchAllPlans({ commit }, childId) {
  await Vue.axios({
    method: 'GET',
    url: '/child/' + childId + '/getPlans/'
  })
    .then(response => {
      commit('setPlans', response.data);
    })
    .catch(error => {
      commit('error', error);
    });
}

export async function createPlan({ commit }, payload) {
  let to_return = '';
  try {
    let data = {
      often_times_per_week: payload.times_of_week,
      where_place: payload.place,
      what_activities: payload.what_activities,
      how_remember: payload.how_remember,
      daysTime: payload.what_days,
      whenCheckDays: payload.where_days,
      child: payload.child,
      module: payload.module,
      extra_data: payload.extra_data
    };
    if (data.extra_data === '') {
      delete data.extra_data;
    }

    const response = await axios.post('/plan/', data);
    to_return = response.data;
  } catch (error) {
    to_return = error;
  }

  return to_return;
}

export async function editPlan({ commit }, payload) {
  //console.log("data", payload )
  //console.log("WhatDays",payload.what_days)
  let data = {
    where_place: payload.place,
    what_activities: payload.what_activities,
    how_remember: payload.how_remember,
    daysTime: payload.what_days,
    whenCheckDays: payload.where_days,
    extra_data_how_remember: payload.extra_data,
    child: payload.child,
    module: payload.module
    // often_times_per_week: payload.times_of_week,
  };
  if (data.extra_data_how_remember == '') {
    delete data.extra_data_how_remember;
  }
  if ('parentEdit' in payload) {
    data['parentEdit'] = 'true';
  }
  try {
    const response = await axios.put(`/plan/${payload.planId}/`, data);
  } catch (error) {
    console.log(error);
  }
}

export async function fetchRememberOptions({ commit }) {
  await Vue.axios({
    method: 'GET',
    url: '/plan/getOptions/'
  })
    .then(response => {
      commit('setOptions', response.data);
    })
    .catch(error => {
      //console.log(error)
    });
}

